(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  window.theme = window.theme || {};

  /* ---------------------------------------------------------------- Toast */
  function toast(message, tone) {
    var region = $('[data-toast-region]');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'toast' + (tone ? ' toast--' + tone : '');
    el.textContent = message;
    region.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 400);
    }, 3400);
  }
  window.theme.toast = toast;

  /* --------------------------------------------------------------- Money */
  var MONEY_FORMAT = window.themeSettings && window.themeSettings.moneyFormat
    ? window.themeSettings.moneyFormat
    : '${{amount}}';

  function formatMoney(cents) {
    var value = (cents || 0) / 100;
    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      switch (key) {
        case 'amount_no_decimals':
          return Math.round(value).toString();
        case 'amount_with_comma_separator':
          return value.toFixed(2).replace('.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return Math.round(value).toString().replace('.', ',');
        case 'amount_with_apostrophe_separator':
          return value.toFixed(2).replace('.', "'");
        default:
          return value.toFixed(2);
      }
    });
  }
  window.theme.formatMoney = formatMoney;

  /* ---------------------------------------------------------------- Cart */
  var Cart = {
    add: function (formData) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Unable to add to cart');
          return data;
        });
      });
    },
    change: function (payload) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) { return res.json(); });
    },
    get: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
    }
  };
  window.theme.cart = Cart;

  function updateCartCount() {
    Cart.get().then(function (cart) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', cart.item_count === 0);
      });
    }).catch(function () {});
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        var current = $('[data-cart-drawer]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          bindDrawer();
        }
      })
      .catch(function () {});
  }

  var drawer = {
    open: function () {
      var el = $('[data-cart-drawer]');
      if (!el) { window.location.href = '/cart'; return; }
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      var focusable = el.querySelector('[data-drawer-close]');
      if (focusable) focusable.focus();
    },
    close: function () {
      var el = $('[data-cart-drawer]');
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
    }
  };
  window.theme.drawer = drawer;

  function bindDrawer() {
    $$('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { drawer.close(); });
    });
    $$('[data-cart-drawer] [data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
        var input = $('[data-drawer-qty="' + line + '"]');
        var current = input ? parseInt(input.value, 10) : 1;
        var next = Math.max(0, current + delta);
        btn.classList.add('is-loading');
        Cart.change({ line: line, quantity: next }).then(function () {
          return Promise.all([refreshDrawer(), updateCartCount()]);
        }).catch(function () { toast('Could not update quantity', 'error'); });
      });
    });
  }

  /* --------------------------------------------------- Cart open buttons */
  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-cart-open]');
    if (openBtn) {
      event.preventDefault();
      if (window.themeSettings && window.themeSettings.cartType === 'page') {
        window.location.href = '/cart';
      } else {
        drawer.open();
      }
      return;
    }

    var closeEl = event.target.closest('[data-cart-close]');
    if (closeEl) { event.preventDefault(); drawer.close(); return; }

    var overlay = event.target.closest('[data-cart-drawer] [data-drawer-overlay]');
    if (overlay) { drawer.close(); }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      drawer.close();
      document.body.classList.remove('nav-open');
      var nav = $('[data-mobile-nav]');
      if (nav) nav.classList.remove('is-open');
    }
  });

  /* ------------------------------------------------------ Product forms */
  function initProductForm(wrapper) {
    var form = wrapper.querySelector('[data-product-form]');
    var jsonEl = wrapper.querySelector('[data-variant-json]');
    if (!form || !jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var idInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add-button]');
    var addButtonText = form.querySelector('[data-add-button-text]');
    var priceEl = wrapper.querySelector('[data-price]');
    var compareEl = wrapper.querySelector('[data-compare-price]');
    var stockEl = wrapper.querySelector('[data-stock]');
    var skuEl = wrapper.querySelector('[data-sku]');
    var groups = $$('[data-option-group]', form);

    function selectedOptions() {
      return groups.map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.getAttribute('data-option-value') : null;
      });
    }

    function findVariant() {
      if (groups.length === 0) {
  return variants[0] || null;
}
      var opts = selectedOptions();
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = v.options.every(function (value, index) { return value === opts[index]; });
        if (match) return v;
      }
      return null;
    }

    function update() {
      var variant = findVariant();
      if (!variant) {
        if (addButton) { addButton.setAttribute('disabled', 'disabled'); }
        if (addButtonText) addButtonText.textContent = 'Unavailable';
        if (stockEl) { stockEl.textContent = 'Unavailable'; stockEl.classList.add('product__stock--out'); }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (stockEl) {
        var available = variant.available;
        stockEl.textContent = available ? 'In stock — instant delivery' : 'Sold out';
        stockEl.classList.toggle('product__stock--out', !available);
      }

      if (addButton) {
        if (variant.available) {
          addButton.removeAttribute('disabled');
          if (addButtonText) addButtonText.textContent = 'Add to cart';
        } else {
          addButton.setAttribute('disabled', 'disabled');
          if (addButtonText) addButtonText.textContent = 'Sold out';
        }
      }

      if (skuEl && variant.sku) skuEl.textContent = variant.sku;

      if (variant.featured_media && variant.featured_media.id) {
        var thumb = wrapper.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb && !thumb.classList.contains('is-active')) thumb.click();
      }
    }

    groups.forEach(function (group) {
      group.addEventListener('change', update);
    });

    update();

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (addButton) addButton.classList.add('is-loading');
      var data = new FormData(form);
      Cart.add(data).then(function () {
        return Promise.all([refreshDrawer(), updateCartCount()]);
      }).then(function () {
        if (window.themeSettings && window.themeSettings.cartType !== 'page') {
          drawer.open();
        } else {
          window.location.href = '/cart';
        }
      }).catch(function (error) {
        toast(error.message || 'Unable to add to cart', 'error');
      }).finally(function () {
        if (addButton) addButton.classList.remove('is-loading');
      });
    });
  }

  /* --------------------------------------------------------- Quick add */
  function initQuickAdd() {
    $$('[data-quick-add]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        var variantId = button.getAttribute('data-quick-add');
        if (!variantId) return;
        button.classList.add('is-loading');
        var data = new FormData();
        data.append('id', variantId);
        data.append('quantity', '1');
        Cart.add(data).then(function () {
          return Promise.all([refreshDrawer(), updateCartCount()]);
        }).then(function () {
          if (window.themeSettings && window.themeSettings.cartType !== 'page') {
            drawer.open();
          } else {
            toast('Added to cart', 'success');
          }
        }).catch(function (error) {
          toast(error.message || 'Unable to add to cart', 'error');
        }).finally(function () {
          button.classList.remove('is-loading');
        });
      });
    });
  }

  /* ----------------------------------------------------- Cart page rows */
  function initCartPage() {
    $$('[data-cart-page-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = parseInt(input.getAttribute('data-cart-page-qty'), 10);
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        Cart.change({ line: line, quantity: quantity }).then(function () {
          window.location.reload();
        });
      });
    });
  }

  /* ---------------------------------------------------- Quantity steppers */
  function initQuantity() {
    $$('[data-quantity]').forEach(function (wrapper) {
      var input = wrapper.querySelector('input');
      if (!input) return;
      $$('[data-quantity-button]', wrapper).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-quantity-button'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var next = (parseInt(input.value, 10) || 1) + step;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------ Product gallery */
  function initGallery() {
    var main = $('[data-product-main-image]');
    if (!main) return;
    $$('[data-media-id]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        var src = thumb.getAttribute('data-media-src');
        var srcset = thumb.getAttribute('data-media-srcset');
        if (src) main.setAttribute('src', src);
        if (srcset) main.setAttribute('srcset', srcset);
        $$('[data-media-id]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        void mediaId;
      });
    });
  }

  /* ------------------------------------------------------------ Header */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });

    var burger = $('[data-nav-open]');
    var nav = $('[data-mobile-nav]');
    if (burger && nav) {
      burger.addEventListener('click', function () {
        nav.classList.add('is-open');
        document.body.classList.add('nav-open');
      });
      $$('[data-nav-close]', nav).forEach(function (btn) {
        btn.addEventListener('click', function () {
          nav.classList.remove('is-open');
          document.body.classList.remove('nav-open');
        });
      });
    }
  }

  /* ----------------------------------------------------------- Reveals */
  function initReveal() {
    var items = $$('[data-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------ Boot */
  function boot() {
    $$('[data-product-form-wrapper]').forEach(initProductForm);
    bindDrawer();
    initQuickAdd();
    initCartPage();
    initQuantity();
    initGallery();
    initHeader();
    initReveal();
    updateCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    bindDrawer();
    initQuickAdd();
    initQuantity();
    initGallery();
    initReveal();
  });
})();
